import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";
import { useAuth } from "./auth";

const AccountsCtx = createContext(null);

export function AccountsProvider({ children }) {
  const { user } = useAuth();
  const [accounts, setAccounts] = useState([]);
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem("cb_account") || "");

  const load = useCallback(async () => {
    if (!user) return;
    const { data } = await api.get("/accounts");
    setAccounts(data);
    // Use functional update so this doesn't re-create on every selectedId change
    setSelectedId((prev) => {
      if (data.find((a) => a.id === prev)) return prev;
      const first = data[0]?.id || "";
      if (first) localStorage.setItem("cb_account", first);
      else localStorage.removeItem("cb_account");
      return first;
    });
  }, [user]);

  useEffect(() => {
    load();
  }, [load]);

  const select = (id) => {
    setSelectedId(id);
    if (id) localStorage.setItem("cb_account", id);
    else localStorage.removeItem("cb_account");
  };

  return (
    <AccountsCtx.Provider
      value={{ accounts, selectedId, select, reload: load, current: accounts.find((a) => a.id === selectedId) }}
    >
      {children}
    </AccountsCtx.Provider>
  );
}

export const useAccounts = () => useContext(AccountsCtx);
